export const GET_WELNESS_ACKNOWLEDGEMENTS_REQUEST = "GET_WELNESS_ACKNOWLEDGEMENTS_REQUEST";
export const GET_WELNESS_ACKNOWLEDGEMENTS_SUCCESS = "GET_WELNESS_ACKNOWLEDGEMENTS_SUCCESS";
export const GET_WELNESS_ACKNOWLEDGEMENTS_FAILURE = "GET_WELNESS_ACKNOWLEDGEMENTS_FAILURE";

export const SET_WELNESS_ACKNOWLEDGEMENTS_META = "SET_WELNESS_ACKNOWLEDGEMENTS_META";
export const RESET_WELNESS_ACKNOWLEDGEMENTS = "RESET_WELNESS_ACKNOWLEDGEMENTS";
